import CustomLink from '@/bit/components/components.custom-link';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';
import IconGlyph from '@/bit/components/components.icon-glyph';

function Header({ cyData }) {
  return (
    <CustomLink
      className="header__link"
      href="https://www.movistar.es"
      ariaLabel="Movistar home"
      taggingInfo={{
        componentName: 'link',
        componentContent: 'LogoM',
        componentVariation: 'all',
        componentPerso: '',
        componentProduct: '',
      }}
      cyData={`${cyData}__link`}
    >
      <IconGlyph
        className="movistar-m--size-s"
        id="Movistar"
        kind="m"
        width={38}
        color={COLOR_DICTIONARY.MOVISTAR_BLUE}
        priority
      />
      <IconGlyph
        className="movistar-m--size-m"
        id="Movistar-letra"
        alt="Movistar-icono"
        kind="m"
        height={26.73}
        width={112}
        color={COLOR_DICTIONARY.MOVISTAR_BLUE}
        priority
      />
      <IconGlyph
        className="movistar-m--size-l"
        id="Movistar-letra"
        kind="m"
        alt="Movistar-icono"
        height={32}
        width={134}
        color={COLOR_DICTIONARY.MOVISTAR_BLUE}
        priority
      />
      <style jsx>
        {`
          :global(.header__link) {
            display: block;
            width: fit-content;
          }
          :global(.movistar-m--size-s) {
            display: inline-block !important;
          }
          :global(.movistar-m--size-m) {
            display: none !important;
          }
          :global(.movistar-m--size-l) {
            display: none !important;
          }
          @media screen and (min-width: 1024px) {
            :global(.movistar-m--size-s) {
              display: none !important;
            }
            :global(.movistar-m--size-m) {
              display: inline-block !important;
            }
            :global(.movistar-m--size-l) {
              display: none !important;
            }
          }
          @media screen and (min-width: 1280px) {
            :global(.movistar-m--size-s) {
              display: none !important;
            }
            :global(.movistar-m--size-m) {
              display: none !important;
            }
            :global(.movistar-m--size-l) {
              display: inline-block !important;
            }
          }
        `}
      </style>
    </CustomLink>
  );
}
export default Header;
